import { FC } from 'react';
import { CatHeading } from '@blocks-react/components/Heading';
import { NotificationHeaderProps } from '../types';

export const NotificationHeader: FC<NotificationHeaderProps> = ({
  title,
  children,
}) => {
  return (
    <>
      <CatHeading
        variant="title"
        slot="header"
        className="text-capitalize"
        id="notification-heading"
        data-testid={'drawer-title-notification'}
        aria-label={title}
      >
        {title}
      </CatHeading>
      <div slot="actions" className="d-flex">
        {children}
      </div>
    </>
  );
};
